<template>
  <div v-bind="cardProps" class="ocard text-gray-600 overflow-hidden md:flex">
    <div class="flex-1 relative md:flex md:justify-center">
      <div class="px-4">
        <OImage
          v-bind="image"
          img-class="rounded min-h-full object-cover mx-auto"
        />
      </div>
      <div v-if="caption" class="text-white absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center">
        <h3 class="ocard-caption" v-html="caption" />
      </div>
    </div>
    <div class="flex-1">
      <slot />
    </div>
  </div>
</template>

<script>
import { getImagePaths } from '@/utils/general'

const OImage = () => import('@/components/OImage')

export default {
  name: 'OCard',
  components: {
    OImage
  },
  props: {
    image: {
      type: Object,
      default: () => getImagePaths({ path: '/images/frontend/loyalty/friends', s3: true })
    },
    caption: {
      type: String,
      default: ''
    },
    attribute: {
      type: Object,
      default: null,
      validator: value => ['name', 'value'].every(prop => value.hasOwnProperty(prop))
    }
  },
  computed: {
    cardProps () {
      return {
        ...(this.attribute ? { [this.attribute.name]: this.attribute.value } : {})
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.ocard {
  &-caption {
    @apply font-display text-center font-black;
    font-size: 4.6rem;
    line-height: 5.742rem;
  }

  .oimage >>> .object-cover {
    @apply object-cover !important;
  }
}

@screen md {
  .ocard {
    &-caption {
      font-size: 6rem;
    }
  }
}
</style>
